import axios from "axios";

const repairCase = function (h, case_id) {
  const promiseFunc = function (resolve, reject) {

    axios
      .post(
        process.env.VUE_APP_API_URL + "/cases/get",
        { _id: case_id },
        { headers: { authorization: localStorage.getItem("vle.user.token") } }
      )
      .then((response) => {
        const _case = response.data;

        _case.data.forEach(d => {
          if (d.choices) {
            d.choices.forEach(c => c.points = +c.points);
            if (d.content === '') delete d.content;
          } else if (d.questions) {
            d.questions.forEach(q => q.points = +q.points);
            if (d.content === '') delete d.content;
          }
        });

        axios.post(
          process.env.VUE_APP_API_URL + '/cases/set',
          { case: _case },
          { headers: { authorization: localStorage.getItem('vle.user.token') } }
        ).then(() => {
          const messageVNode = h('div', {}, [
            h('strong', 'Repairs'),
            h('ul', {}, [
              h('li', 'fixed questions and decision points'),
              h('li', 'removed empty content from questions and decisions')
            ])
          ]);
          resolve(messageVNode);
        }).catch(err => reject(err));

      }).catch(err => reject(err));

  }
  return new Promise(promiseFunc);
}


const repairPlayer = function (h, player_id) {
  const promiseFunc = function (resolve, reject) {

    const { setLog, getLog, updateScore } = require('./play-utils');

    axios.post(
      process.env.VUE_APP_API_URL + '/players/get',
      { _id: player_id },
      { headers: { authorization: localStorage.getItem('vle.user.token') } }
    ).then((result) => {
      let player = result.data;

      //fix selected items
      player.logs.forEach(l => {
        l.data.forEach(d => {
          if (d.choices) {
            d.choices.forEach(c => {
              c.selected = c.selected === "true" ? true : (c.selected === "false" ? false : c.selected);
            });
          } else if (d.questions) {
            d.questions.forEach(q => {
              q.selected = q.selected === "true" ? true : (q.selected === "false" ? false : q.selected);
            });
          }
        });
      });

      let promises = [];
      player.logs.forEach(l => {
        promises.push(
          axios.post(process.env.VUE_APP_API_URL + "/play/getCase",
            { _id: l.case_id },
            { headers: { authorization: localStorage.getItem('vle.user.token') } }
          )
        )
      });

      Promise.allSettled(promises).then((results) => {
        //fix scores
        results.forEach((r, i) => {
          const _case = r.value.data;
          setLog(_case, player.logs[i]);
          _case.data.forEach(doc => {
            updateScore(doc, _case);
          });
          player.logs[i] = getLog(_case);
        });

        axios.post(
          process.env.VUE_APP_API_URL + '/players/set',
          { player: player },
          { headers: { authorization: localStorage.getItem('vle.user.token') } }
        ).then(() => {
          const messageVNode = h('div', {}, [
            h('strong', 'Repairs'),
            h('ul', {}, [
              h('li', 'fixed logs')
            ])
          ]);
          resolve(messageVNode);
        });
      }).catch(err => reject(err));

    }).catch(err => reject(err));
  }
  return new Promise(promiseFunc);
}

export {
  repairCase,
  repairPlayer
};